module.exports = {
    name:'星途保',
    apihost:'https://api.xtb365.cn',
	etcApihost:'https://api.etc.xtb365.cn',
    // apihost:'http://xtb.test/api/public',
    // etcApihost:'http://xtb.test/api/public',
    apimit:{
        device:'ADMIN',
        compiled:{
            ADMIN:"dhauo1234420123gg3234901",// 接口Sign混淆秘钥
        }
    },
}